<blaze-dialog (closeDialog)="action('cancel')" [showFooter]="true" class="confirm-dialog">
  <div title>
    {{ dialogData.title }}
  </div>

  <div content class="modal-content px-24 markdown">
    @if (dialogData.messageFormat === 'markdown') {
      <div data-cy="DialogConfirm:textContent" [innerHTML]="dialogData.message | markdown"></div>
    } @else {
      <div data-cy="DialogConfirm:textContent" [innerHTML]="dialogData.message"></div>
    }
  </div>

  <div footer class="flex w-full justify-center items-center gap-8 flex-row-reverse">
    @for (btn of dialogData.buttons; track btn) {
      <button class="bd-btn uppercase" (click)="action(btn.action ?? 'continue')">
        <div class="shade"></div>
        {{ btn.label }}
      </button>
    }
  </div>
</blaze-dialog>
